/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SharedMobileMoreWaysToBrowse_viewer$ref = any;
export type SharedMobileMoreWaysToBrowse_viewer = {
    readonly isMoreWaysToBrowseEnabled: boolean | null;
    readonly " $refType": SharedMobileMoreWaysToBrowse_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SharedMobileMoreWaysToBrowse_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isMoreWaysToBrowseEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "MORE_WAYS_TO_BROWSE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"MORE_WAYS_TO_BROWSE\")"
        }
    ]
} as any);
(node as any).hash = '5bba947f568618895741bd3eb235f4c1';
export default node;
